// @ts-nocheck
import React, { Component } from "react";
import { CommonNav } from "../CommonNav";
import { isUserAdmin, isUserOrgAdmin, canManageUsers } from "../../../utils/util";

export class MainNav extends Component {
  render() {
    let menuItems = [
      {
        path: "/welcome",
        imgPath: "/assets/images/home-02.svg",
        title: "Home"
      },
      {
        path: "/components",
        imgPath: "/assets/images/beaker-02.svg",
        title: "Web Test Lab"
      },
      // Execution Reports is a free feature — promoted to top-level so users
      // on any plan see it without going through the paid Automation Metrics
      // umbrella. The paid Automation Metrics tab keeps Test Creation +
      // Cost Saving as its sub-tabs (see MetricsNavigation.tsx).
      {
        path: "/metrics/execution-reports",
        imgPath: "/assets/images/line-chart-up-02.svg",
        title: "Execution Reports"
      },
      {
        path: "/metrics",
        imgPath: "/assets/images/line-chart-up-02.svg",
        title: "Automation Metrics",
        // Small visual hint that this section is paid. When license gating
        // is wired up, this can be swapped for a hasFeature() check on the
        // menuItem itself and the badge becomes conditional.
        badge: "PRO"
      },
      {
        path: "/tcm",
        imgPath: "/assets/images/manual-testing-icon.svg",
        title: "Test Case Management"
      },
      /*{
        title: "Software Management",
        imgPath: "/assets/images/globe-06.svg",
        children: [
          {
            title: "Requirement List",
            path: "/requirements"
          },
          {
            title: "Agile Artifacts List",
            path: "/artifacts"
          },
          {
            title: "Risk Dashboard",
            path: "/risk-dashboard"
          },
          {
            title: "Test Mapping",
            path: "/test-mapping"
          },
          {
            title: "Script List",
            path: "/scriptsdata"
          },
          {
            title: "Orphan Test View",
            path: "/orphan-tests"
          },
          {
            title: "Kanban Board",
            path: "/kanboard"
          },
          {
            title: "Timeline",
            path: "/timeline"
          },
          {
            title: "Workflow Editor",
            path: "/workflow"
          },
          /!*{
            title: "NLP",
            path: "/nlp/1" // Example default path
          },*!/
          {
            title: "Architecture Diagram",
            path: "/diagram"
          },
          {
            title: "Collaboration",
            path: "/collaborations"
          },
          {
            title: "Surverytemplate",
            path: "/surveytemplates"
          },
          {
            title: "Use Case",
            path: "/usecases"
          },
          {
            title: "Dashboard",
            path: "/dashboard-configs"
          },
          {
            title: "Specifications",
            path: "/spec"
          },
          {
            title: "Test Link",
            path: "/testlinks"
          }
        ]
      },*/
      // Project Management — hidden until launched as separate product
      // {
      //   path: "/pm",
      //   imgPath: "/assets/images/kanban-logo.svg",
      //   title: "Project"
      // },
      {
        path: "/controllers",
        redirectPath: "/controllers/add-license",
        imgPath: "/assets/images/shield-tick.svg",
        title: "License"
      },
      {
        path: "/help",
        redirectPath: "/help",
        imgPath: "/assets/images/help-circle-light.svg",
        title: "Help"
      },
      {
        path: "/privacy-policy",
        redirectPath: "/privacy-policy",
        imgPath: "/assets/images/file-heart-02.svg",
        title: "Privacy Policy"
      }
    ];
    // Show User menu for both admins and org-admins
    if (canManageUsers()) {
      menuItems = [
        ...menuItems,
        {
          path: "/user",
          redirectPath: "/user",
          imgPath: "/assets/images/user-02.svg",
          title: "User"
        }
      ];
    }
    // Show Audit menu only for admins (super users)
    if (isUserAdmin()) {
      menuItems = [
        ...menuItems,
        {
          path: "/audit",
          redirectPath: "/audit",
          imgPath: "/assets/images/Flag-02.svg",
          title: "Audit"
        }
      ];
    }
    return <CommonNav navItems={menuItems} />;
  }
}
